import LogInBg from "../Assets/Images/bg.webp"
import LogInLogo from "../Assets/Images/logo-2-removebg.png"
import HeaderLogo from "../Assets/Images/output (9).jpg"

export const HEADER_LOGO = HeaderLogo

export const LOGIN_BG = LogInBg

export const LOGIN_LOGO = LogInLogo